import { Button, Grid, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import NormalAbnormal from '../NormalAbnormal'
import CustomSelect from '../CustomSelect'
import AssessmentText from '../AssessmentText'

const Skin = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} lg={6}>
        <Typography variant="title2">Skin Assessment</Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <AnDateTimePicker
          date={moduleValues.dateTime}
          fullWidth
          size="small"
          onChange={(newDate) =>
            setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
          }
        />
      </Grid>
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Skin Colour"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Temperature"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Moisture"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Capillary Refill"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Turgor"
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Oedema"
        options={[
          'No Oedema',
          'Slight Oedema',
          'Moderate Oedema',
          'Severe Oedema',
        ]}
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Cellulitis"
        options={['No Signs of Cellulitis', 'Signs of Cellulitis']}
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Rash"
        options={['No Rash', 'Rash']}
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Bruising"
        options={['No Bruising', 'Bruising']}
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Blisters"
        options={['No Blisters', 'Blisters']}
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Burns"
        options={['No Burns', 'Burns']}
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Wounds"
        options={['No Wounds', 'Wounds']}
      />
      <AssessmentText moduleValues={moduleValues} setModuleValues={setModuleValues} />
      <Grid item xs={12}>
        <Button
          onClick={() => submitModule('Skin', moduleValues)}
          variant="contained"
          color="success"
          fullWidth
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default Skin
